import { render, staticRenderFns } from "./BusinessSelector.vue?vue&type=template&id=bbd08da2&scoped=true&"
import script from "./BusinessSelector.vue?vue&type=script&lang=js&"
export * from "./BusinessSelector.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSelector.vue?vue&type=style&index=0&id=bbd08da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd08da2",
  null
  
)

export default component.exports